<template>
  <div>
    <v-layout>
      <v-flex>
        <v-layout>
          <v-flex style="padding: 2% 5% 2% 5%">
            <v-card flat class="pb-8">
              <!-- Upload Image -->
              <v-layout style="position: absolute; right: 80px;top: 90px">
                <v-flex>
                  <div
                    class="mb-1"
                    style="background-color: #FAF5F2; max-width: 103px;height: 123px;box-shadow: 0 2px 6px rgba(0,0,0,0.5);text-align: center"
                  >
                    <img
                      :src="imageUrl"
                      style="width: 100%;height: 100%;object-fit: cover"
                    />
                  </div>
                  <v-file-input
                    id="file"
                    label="File input"
                    style="display: none;"
                    @change="onFilePicked"
                  ></v-file-input>
                  <v-btn
                    style="width: 103px;font-size: 12px"
                    color="#3E7662"
                    dark
                    @click="uploadFile"
                  >
                    <v-icon class="pr-3">cloud_download</v-icon>
                    <span>Upload</span>
                  </v-btn>
                </v-flex>
              </v-layout>

              <!-- Header -->
              <v-layout
                mb-12
                pa-8
                justify-center
                style="background-color: #3E7662;"
              >
                <v-flex style="text-align: left;">
                  <span style="font-weight: bold;font-size: 28px;color: white;"
                    >แบบฟอร์มลงทะเบียน</span
                  >
                </v-flex>
                <v-flex style="text-align: right;">
                  <!--                            <span style="font-size: 14px;color: white;">Version……….Date…………………….</span><br>-->
                  <span style="font-size: 14px;color: white;">RF 10_2560</span>
                </v-flex>
              </v-layout>

              <!-- Form Register -->
              <v-layout justify-center>
                <v-flex xs12 sm10 md8 lg10 pt-8 pb-12>
                  <!-- E-mail -->
                  <v-layout>
                    <v-flex
                      mr-8
                      xs3
                      class="font-weight-bold d-flex align-center justify-end"
                    >
                      <span
                        >อีเมลใช้ลงทะเบียน<span style="color: #CC3D45"
                          >*</span
                        ></span
                      >
                    </v-flex>
                    <v-flex xs6 class="text-input">
                      <TextfieldForm
                        id="email"
                        :model="form.email"
                        @update-data="updateData('email', $event)"
                        hide-detail
                      ></TextfieldForm>
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                  <v-layout>
                    <v-flex mr-8 pt-2 xs3 style="text-align: right;"></v-flex>
                    <v-flex
                      class="text-input font-weight-bold"
                      style="text-align: right;"
                    >
                      <span style="font-size: 12px;color: #CC3D45"
                        >หมายเหตุ : กรุณาใช้อีเมลของสำนักงาน หรือ G-mail
                        เท่านั้น*</span
                      >
                    </v-flex>
                    <v-flex xs3 pl-8 pt-3 style="text-align: left"></v-flex>
                  </v-layout>

                  <!-- Password -->
                  <v-layout mt-12 v-if="$route.query.id === 'add'">
                    <v-flex
                      mr-8
                      xs3
                      class="font-weight-bold d-flex align-center justify-end"
                    >
                      <span>รหัสผ่าน<span style="color: #CC3D45">*</span></span>
                    </v-flex>
                    <v-flex xs6 class="text-input">
                      <TextfieldForm
                        id="password"
                        hide-detail
                        type="password"
                        :model="form.password"
                        @update-data="updateData('password', $event)"
                      ></TextfieldForm>
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>
                  <v-layout class="mt-8" v-if="$route.query.id === 'add'">
                    <v-flex
                      mr-8
                      xs3
                      class="font-weight-bold d-flex align-center justify-end"
                    >
                      <span
                        >ยืนยันรหัสผ่าน<span style="color: #CC3D45"
                          >*</span
                        ></span
                      >
                    </v-flex>
                    <v-flex xs6 class="text-input">
                      <TextfieldForm
                        id="password_confirmation"
                        hide-detail
                        type="password"
                        :model="form.password_confirmation"
                        @update-data="
                          updateData('password_confirmation', $event)
                        "
                      ></TextfieldForm>
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>

                  <v-layout mt-12>
                    <v-flex
                      mr-8
                      xs3
                      class="font-weight-bold d-flex align-center justify-end"
                    >
                      <span
                        >ประเภทผู้ใช้งาน<span style="color: #CC3D45"
                          >*</span
                        ></span
                      >
                    </v-flex>
                    <v-flex xs6 class="text-input">
                      <v-select
                        outlined
                        :menu-props="{ bottom: true, offsetY: true }"
                        flat
                        background-color="#FBF6F3"
                        item-color="#3E7662"
                        dense
                        color="#3E7662"
                        id="role"
                        placeholder="เลือก ประเภทผู้ใช้งาน"
                        :items="roleList"
                        hide-details
                        multiple
                        item-text="role"
                        itemValue="roleID"
                        v-model="form.role"
                      />
                    </v-flex>
                    <v-spacer></v-spacer>
                  </v-layout>

                  <v-layout v-if="form.role">
                    <v-flex>
                      <v-layout class="mt-8">
                        <v-flex
                          mr-8
                          pt-1
                          xs3
                          class="font-weight-bold d-flex align-center justify-end"
                        >
                          เพศ
                        </v-flex>
                        <v-flex>
                          <v-radio-group
                            id="gender"
                            v-model="form.gender"
                            hide-details
                            row
                          >
                            <v-radio
                              color="#3E7662"
                              style="padding-right: 100px"
                              label="ชาย"
                              value="1"
                            ></v-radio>
                            <v-radio
                              color="#3E7662"
                              style="padding-right: 100px"
                              label="หญิง"
                              value="2"
                            ></v-radio>
                          </v-radio-group>
                        </v-flex>
                      </v-layout>
                      <!-- ชื่อ-นามสกุล -->
                      <v-layout class="mt-8">
                        <v-flex
                          mr-8
                          pt-1
                          xs3
                          class="font-weight-bold d-flex align-center justify-end"
                        >
                          <span
                            >คำนำหน้าชื่อ<span style="color: #CC3D45"
                              >*</span
                            ></span
                          >
                        </v-flex>
                        <v-flex xs6 class="field-select">
                          <v-layout>
                            <v-flex class="pr-2">
                              <TextfieldForm
                                  id="preNameTh"
                                  placeholder="ยศ ภาษาไทย"
                                  hide-detail
                                  :model="form.preNameTh"
                                  @update-data="updateData('preNameTh', $event)">
                              </TextfieldForm>
                            </v-flex>
                            <v-flex class="pl-2">
                              <TextfieldForm
                                  id="preNameEn"
                                  placeholder="ยศ ภาษาอังกฤษ"
                                  hide-detail
                                  :model="form.preNameEn"
                                  @update-data="updateData('preNameEn', $event)">
                              </TextfieldForm>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                        <v-flex
                          pl-8
                          class="font-weight-bold d-flex align-center justify-start"
                        >
                          <span>(ยศ)</span>
                        </v-flex>
                      </v-layout>

                      <v-layout class="mt-8">
                        <v-flex mr-8 pt-2 xs3
                                class="font-weight-bold d-flex align-center justify-end"
                                style="text-align: right;">
                  <span
                  >1. ชื่อ-นามสกุล<span style="color: #CC3D45">*</span></span
                  >
                        </v-flex>
                        <v-flex xs3 pr-2 class="text-input">
                          <TextfieldForm
                              id="thFirstName"
                              placeholder="ชื่อจริงภาษาไทย"
                              hide-detail
                              :model="form.thFirstName"
                              @update-data="updateData('thFirstName', $event)"
                          ></TextfieldForm>
                        </v-flex>
                        <v-flex xs3 pl-2 class="text-input">
                          <TextfieldForm
                              id="thLastName"
                              placeholder="นามสกุลภาษาไทย"
                              hide-detail
                              :model="form.thLastName"
                              @update-data="updateData('thLastName', $event)"
                          ></TextfieldForm>
                        </v-flex>
                        <v-flex
                            pl-8
                            class="font-weight-bold d-flex align-center justify-start"
                        >
                          <span>(ภาษาไทย)</span>
                        </v-flex>
                      </v-layout>

                      <v-layout class="mt-8">
                        <v-flex mr-8 pt-2 xs3 style="text-align: right;"> </v-flex>
                        <v-flex xs3 pr-2 class="text-input">
                          <TextfieldForm
                              id="enFirstName"
                              placeholder="ชื่อจริงอังกฤษ"
                              hide-detail
                              :model="form.enFirstName"
                              @update-data="updateData('enFirstName', $event)"
                          ></TextfieldForm>
                        </v-flex>
                        <v-flex xs3 pl-2 class="text-input">
                          <TextfieldForm
                              id="enLastName"
                              placeholder="นามสกุลอังกฤษ"
                              hide-detail
                              :model="form.enLastName"
                              @update-data="updateData('enLastName', $event)"
                          ></TextfieldForm>
                        </v-flex>
                        <v-flex
                            pl-8
                            class="font-weight-bold d-flex align-center justify-start"
                        >
                          <span>(ภาษาอังกฤษ)</span>
                        </v-flex>
                      </v-layout>

                      <v-layout class="mt-8">
                        <v-flex
                          mr-8
                          pt-1
                          xs3
                          class="font-weight-bold d-flex align-center justify-end"
                        >
                          <span
                            >เบอร์โทรศัพท์มือถือ<span style="color: #CC3D45"
                              >*</span
                            ></span
                          >
                        </v-flex>
                        <v-flex xs6>
                          <TextfieldForm
                            id="sub-committee-mobile"
                            placeholder="เบอร์โทรศัพท์มือถือ"
                            hide-detail
                            :model="form.mobilePhone"
                            @update-data="updateData('mobilePhone', $event)"
                          ></TextfieldForm>
                        </v-flex>
                      </v-layout>

                      <v-layout class="mt-8">
                        <v-flex
                            mr-8
                            pt-1
                            xs3
                            class="font-weight-bold d-flex align-center justify-end"
                        >
                          <div>
                            Upload Signature TH<span style="color: #CC3D45"
                          >*</span
                          >
                          </div>
                        </v-flex>
                        <v-flex xs6 class="field-select">
                          <v-layout>
                            <v-flex shrink>
                              <v-card flat>
                                <loading
                                    color="#527281"
                                    :active.sync="isLoadingUpload"
                                    :can-cancel="false"
                                    :is-full-page="false"
                                ></loading>
                                <v-layout>
                                  <v-flex
                                      style="background-color: #FAF5F2;height: 94px; max-width: 171px;box-shadow: 0 2px 6px rgba(0,0,0,0.5);text-align: center"
                                  >
                                    <img
                                        :src="imageUrlSignature"
                                        style="max-height: 100%;max-width: 100%;object-fit: cover;width: 100%;"
                                    />
                                  </v-flex>
                                </v-layout>
                                <v-layout>
                                  <v-flex class="text-start">
                                    <v-file-input
                                        accept=".png"
                                        ref="signature"
                                        id="signature"
                                        label="File input"
                                        style="display: none;"
                                        @change="onUploadSignaturePicked"
                                    ></v-file-input>
                                    <v-btn
                                        style="width: 171px;font-size: 12px"
                                        color="#3E7662"
                                        dark
                                        @click="uploadSignature"
                                    >
                                      <v-icon class="pr-3"
                                      >cloud_download</v-icon
                                      >
                                      <span>Upload</span>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-flex>
                            <v-flex
                                pl-4
                                class="font-weight-bold text-start justify-start"
                                style="color: #CC3D45;font-weight: bold;font-size: 14px;"
                            >
                              <div>* นามสกุลรูปภาพต้องเป็น .png</div>
                              <div>* ขนาดภาพต้องไม่เกิน 2 MB</div>
                              <div>
                                * ขนาดภาพต้องมีขนาด กว้าง 171 px สูง 94 px
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>
                      <v-layout class="mt-8">
                        <v-flex
                            mr-8
                            pt-1
                            xs3
                            class="font-weight-bold d-flex align-center justify-end"
                        >
                          <div>
                            Upload Signature EN<span style="color: #CC3D45"
                          >*</span
                          >
                          </div>
                        </v-flex>
                        <v-flex xs6 class="field-select">
                          <v-layout>
                            <v-flex shrink>
                              <v-card flat>
                                <loading
                                    color="#527281"
                                    :active.sync="isLoadingUpload"
                                    :can-cancel="false"
                                    :is-full-page="false"
                                ></loading>
                                <v-layout>
                                  <v-flex
                                      style="background-color: #FAF5F2;height: 94px; max-width: 171px;box-shadow: 0 2px 6px rgba(0,0,0,0.5);text-align: center"
                                  >
                                    <img
                                        :src="imageUrlSignatureEN"
                                        style="max-height: 100%;max-width: 100%;object-fit: cover;width: 100%;"
                                    />
                                  </v-flex>
                                </v-layout>
                                <v-layout>
                                  <v-flex class="text-start">
                                    <v-file-input
                                        accept=".png"
                                        ref="signatureEN"
                                        id="signatureEN"
                                        label="File input"
                                        style="display: none;"
                                        @change="onUploadSignaturePickedEN"
                                    ></v-file-input>
                                    <v-btn
                                        style="width: 171px;font-size: 12px"
                                        color="#3E7662"
                                        dark
                                        @click="uploadSignatureEN"
                                    >
                                      <v-icon class="pr-3"
                                      >cloud_download</v-icon
                                      >
                                      <span>Upload</span>
                                    </v-btn>
                                  </v-flex>
                                </v-layout>
                              </v-card>
                            </v-flex>
                            <v-flex
                                pl-4
                                class="font-weight-bold text-start justify-start"
                                style="color: #CC3D45;font-weight: bold;font-size: 14px;"
                            >
                              <div>* นามสกุลรูปภาพต้องเป็น .png</div>
                              <div>* ขนาดภาพต้องไม่เกิน 2 MB</div>
                              <div>
                                * ขนาดภาพต้องมีขนาด กว้าง 171 px สูง 94 px
                              </div>
                            </v-flex>
                          </v-layout>
                        </v-flex>
                      </v-layout>

                      <!-- อนุกรรมการ -->
                      <div v-if="form.role.includes(3)">
                        <!-- สาขาที่เชี่ยวชาญ -->
                        <v-layout class="mt-8">
                          <v-flex
                            mr-8
                            xs3
                            class="font-weight-bold d-flex align-center justify-end"
                          >
                            <span
                              >สาขาที่เชี่ยวชาญ<span style="color: #CC3D45"
                                >*</span
                              ></span
                            >
                          </v-flex>
                          <v-flex xs6 class="text-input">
                            <text-autocomplete
                              id="scMastery"
                              placeholder="สาขา"
                              :items="fieldList"
                              hide-details
                              item-text="field_name"
                              itemValue="field_name"
                              :model="form.scMastery"
                              @update-data="updateData('scMastery', $event)"
                            />
                          </v-flex>
                          <v-flex xs2>
                            <v-flex
                              class="font-weight-bold d-flex align-center "
                            >
                              <span style="padding-left: 8px;padding-right: 8px"
                                >ระบุ</span
                              >
                              <TextfieldForm
                                :background-color="
                                  isOtherField
                                    ? 'rgba(183,183,183,0.79)'
                                    : '#FBF6F3'
                                "
                                :disabled="isOtherField"
                                id="otherScMastery"
                                hide-detail
                                :model="form.otherScMastery"
                                @update-data="
                                  updateData('otherScMastery', $event)
                                "
                              ></TextfieldForm>
                            </v-flex>
                          </v-flex>
                          <v-spacer></v-spacer>
                        </v-layout>

                        <!-- ตำแหน่งทางวิชาการ -->
                        <v-layout class="mt-8">
                          <v-flex
                            mr-8
                            xs3
                            class="font-weight-bold d-flex align-center justify-end"
                          >
                            <span
                              >ตำแหน่งทางวิชาการ<span style="color: #CC3D45"
                                >*</span
                              ></span
                            >
                          </v-flex>
                          <v-flex xs6 class="text-input">
                            <text-autocomplete
                              id="scPosition"
                              placeholder="ตำแหน่ง"
                              :items="positionList"
                              hide-details
                              item-text="position_name"
                              itemValue="position_name"
                              :model="form.scPosition"
                              @update-data="updateData('scPosition', $event)"
                            />
                          </v-flex>
                          <v-flex xs2>
                            <v-flex
                              class="font-weight-bold d-flex align-center "
                            >
                              <span style="padding-left: 8px;padding-right: 8px"
                                >ระบุ</span
                              >
                              <TextfieldForm
                                :background-color="
                                  isOtherPosition
                                    ? 'rgba(183,183,183,0.79)'
                                    : '#FBF6F3'
                                "
                                :disabled="isOtherPosition"
                                id="otherScPosition"
                                hide-detail
                                :model="form.otherScPosition"
                                @update-data="
                                  updateData('otherScPosition', $event)
                                "
                              ></TextfieldForm>
                            </v-flex>
                          </v-flex>
                          <v-spacer></v-spacer>
                        </v-layout>
                        <!-- กอง -->
                        <v-layout class="mt-8">
                          <v-flex
                            mr-8
                            xs3
                            class="font-weight-bold d-flex align-center justify-end"
                          >
                            <span
                              >กอง<span style="color: #CC3D45"
                                >*</span
                              ></span
                            >
                          </v-flex>
                          <v-flex xs6 class="text-input">
                            <text-autocomplete
                              id="scTeam"
                              placeholder="กอง"
                              :items="teamList"
                              hide-details
                              item-text="team_name"
                              itemValue="team_name"
                              :model="form.scTeam"
                              @update-data="updateData('scTeam', $event)"
                            />
                          </v-flex>
                          <v-flex xs2>
                            <v-flex
                              class="font-weight-bold d-flex align-center "
                            >
                              <span style="padding-left: 8px;padding-right: 8px"
                                >ระบุ</span
                              >
                              <TextfieldForm
                                :background-color="
                                  isOtherTeam
                                    ? 'rgba(183,183,183,0.79)'
                                    : '#FBF6F3'
                                "
                                :disabled="isOtherTeam"
                                id="otherScTeam"
                                hide-detail
                                :model="form.otherScTeam"
                                @update-data="
                                  updateData('otherScTeam', $event)
                                "
                              ></TextfieldForm>
                            </v-flex>
                          </v-flex>
                          <v-spacer></v-spacer>
                        </v-layout>

                        <!-- สังกัด -->
                        <v-layout class="mt-8">
                          <v-flex
                            xs3
                            mr-8
                            class="font-weight-bold d-flex align-center justify-end"
                          >
                            <span
                              >สังกัด<span style="color: #CC3D45">*</span></span
                            >
                          </v-flex>
                          <v-flex xs6 class="text-input">
                            <text-autocomplete
                              id="scAffiliation"
                              placeholder="สังกัด"
                              :items="affiliationList"
                              hide-details
                              item-text="affiliation_name"
                              itemValue="affiliation_id"
                              :model="form.scAffiliation"
                              @update-data="updateData('scAffiliation', $event)"
                            />
                          </v-flex>
                          <v-flex xs2>
                            <v-flex
                              class="font-weight-bold d-flex align-center "
                            >
                              <span style="padding-left: 8px;padding-right: 8px"
                                >ระบุ</span
                              >
                              <TextfieldForm
                                :background-color="
                                  isOtherAffiliation
                                    ? 'rgba(183,183,183,0.79)'
                                    : '#FBF6F3'
                                "
                                :disabled="isOtherAffiliation"
                                id="otherScAffiliation"
                                hide-detail
                                :model="form.otherScAffiliation"
                                @update-data="
                                  updateData('otherScAffiliation', $event)
                                "
                              ></TextfieldForm>
                            </v-flex>
                          </v-flex>
                          <v-spacer></v-spacer>
                        </v-layout>

                        <v-layout class="mt-8">
                          <v-flex
                            mr-8
                            pt-1
                            xs3
                            class="font-weight-bold d-flex align-center justify-end"
                          ></v-flex>
                          <v-flex xs6>
                            <v-radio-group
                              v-model="form.isScientist"
                              hide-details
                              row
                            >
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 100px"
                                label="Scientist"
                                value="1"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 100px"
                                label="Non Scientist"
                                value="2"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>

                        <!-- is affiliated /non-affiliated -->
                        <v-layout class="mb-8 mt-4">
                          <v-flex
                            mr-8
                            pt-1
                            xs3
                            class="font-weight-bold d-flex align-center justify-end"
                          ></v-flex>
                          <v-flex xs6>
                            <v-radio-group
                              v-model="form.isAffiliated"
                              hide-details
                              row
                            >
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 100px"
                                label="Affiliated"
                                value="1"
                              ></v-radio>
                              <v-radio
                                color="#3E7662"
                                style="padding-right: 100px"
                                label="Non-Affiliated"
                                value="2"
                              ></v-radio>
                            </v-radio-group>
                          </v-flex>
                        </v-layout>
                      </div>

                      <!-- อนุกรรมการ -->
                      <div v-if="form.role.includes(3)">
                        <v-layout class="mt-8">
                          <v-flex
                            pt-1
                            xs3
                            class="font-weight-bold d-flex align-center justify-end"
                          >
                            <span
                              >คำสั่งแต่งตั้ง<span style="color: #CC3D45"
                                >*</span
                              ></span
                            >
                          </v-flex>
                          <v-flex xs6 class="ml-8">
                            <v-layout>
                              <v-flex
                                xs4
                                pr-2
                                class="font-weight-bold d-flex align-center justify-end"
                              >
                                <span>เลขที่คำสั่ง</span>
                              </v-flex>
                              <v-flex>
                                <TextfieldForm
                                  id="orderNumber"
                                  hide-detail
                                  :model="form.orderNumber"
                                  @update-data="
                                    updateData('orderNumber', $event)
                                  "
                                ></TextfieldForm>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-spacer></v-spacer>
                        </v-layout>
                        <v-layout class="mt-8">
                          <v-flex xs3></v-flex>
                          <v-flex xs6 class="ml-8">
                            <v-layout>
                              <v-flex
                                xs4
                                pr-2
                                class="font-weight-bold d-flex align-center justify-end"
                              >
                                <span>แต่งตั้งเมื่อวันที่</span>
                              </v-flex>
                              <v-flex>
                                <DateInputForm
                                  id="orderDate"
                                  hide-detail
                                  :model="orderChangeDate"
                                  @update-data="updateDate('orderDate', $event)"
                                ></DateInputForm>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                          <v-spacer></v-spacer>
                        </v-layout>
                      </div>

                      <!-- อนุกรรมการ -->
                      <div v-if="form.role.includes(3)">
                        <v-layout mb-6 mt-12>
                          <v-flex
                            shrink
                            pr-4
                            style="text-align: left;"
                            class="d-flex align-center"
                          >
                            <span style="font-weight: bold;font-size: 16px;"
                              >การเข้ารับการอบรม</span
                            >
                          </v-flex>
                          <v-spacer></v-spacer>
                          <v-flex shrink style="text-align: left;">
                            <v-btn
                              dark
                              style="width: 80px;background-color: #3E7662"
                              @click="add(1)"
                            >
                              <v-icon>add</v-icon>
                              <span class="font-weight-bold">เพิ่ม</span>
                            </v-btn>
                          </v-flex>
                        </v-layout>
                        <v-layout mb-12>
                          <v-flex>
                            <div v-for="(input, k) in fixTraining" :key="k">
                              <v-layout>
                                <v-flex
                                  shrink
                                  ml-6
                                  mr-4
                                  mb-6
                                  class="text-end d-flex align-center font-weight-bold"
                                >
                                  <span>ชื่อการอบรม</span>
                                </v-flex>
                                <v-flex xs4>
                                  <TextfieldForm
                                    :readonly="k <= 2"
                                    hide-details
                                    :menu-props="{
                                      bottom: true,
                                      offsetY: true,
                                    }"
                                    background-color="#3E7662"
                                    :model="input.trainingName"
                                    solo
                                    flat
                                    dense
                                    dark
                                    @update-data="updateTrainingName(k, $event)"
                                  >
                                    ></TextfieldForm
                                  >
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex
                                  shrink
                                  ml-6
                                  mr-4
                                  mb-6
                                  class="text-end d-flex align-center font-weight-bold"
                                >
                                  <span>วันที่เข้าอบรม</span>
                                </v-flex>
                                <v-flex xs4>
                                  <DateInputForm
                                    id="trainingDate"
                                    hide-detail
                                    :model="input.trainingDateShow"
                                    @update-data="updateTrainingDate(k, $event)"
                                  >
                                  </DateInputForm>
                                </v-flex>
                                <v-spacer></v-spacer>
                                <v-flex ml-6 xs1 class="justify-end">
                                  <v-btn
                                    dark
                                    style="background-color: #CC3D45; width: 80px"
                                    @click="remove(k)"
                                    :disabled="k < 3"
                                  >
                                    <v-icon>remove</v-icon>
                                    <span class="font-weight-bold">ลบ</span>
                                  </v-btn>
                                </v-flex>
                              </v-layout>
                            </div>
                          </v-flex>
                        </v-layout>
                      </div>
                    </v-flex>
                  </v-layout>
                </v-flex>
              </v-layout>
            </v-card>
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex mb-12 style="padding: 0 5% 2% 5%; text-align: right;">
            <v-layout>
              <v-flex class="text-start">
                <v-btn depressed dark color="#CC3D45" @click="deleteUser"
                  >ลบข้อมูล</v-btn
                >
              </v-flex>
              <v-spacer></v-spacer>
              <v-flex>
                <v-btn
                  style="color: #3E7662"
                  class="mx-4"
                  depressed
                  color="#ffffff"
                  @click="$router.go(-1)"
                  >ย้อนกลับ</v-btn
                >
                <v-btn
                  v-if="$route.query.id === 'add'"
                  depressed
                  dark
                  color="#3E7662"
                  @click="updateUser"
                  >ยืนยันการลงทะเบียน</v-btn
                >
                <v-btn v-else depressed dark color="#3E7662" @click="updateUser"
                  >แก้ไขข้อมูล</v-btn
                >
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <loading
      color="#527281"
      :active.sync="isLoading"
      :can-cancel="false"
      :is-full-page="false"
    ></loading>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import TextfieldForm from "../../components/input/TextfieldForm";
import TextareaForm from "../../components/input/TextareaForm";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import "vue-select/dist/vue-select.css";
import TextAutocomplete from "../../components/input/TextAutocomplete";
import DateInputForm from "../../components/input/DateInputForm";
import MultiselectForm from "../../components/input/MultiselectForm";
import axios from "axios";
import { domain } from "../../services/Constants";
import Service from "../../services";

export default {
  name: "FormUser",
  components: {
    DateInputForm,
    TextfieldForm,
    TextareaForm,
    Loading,
    TextAutocomplete,
    MultiselectForm,
  },
  data: () => ({
    isLoadingUpload: false,
    isLoading: false,
    fieldList: [
      { field_id: 1, field_name: "สูตินรีเวชกรรม" },
      { field_id: 2, field_name: "ศัลยกรรม" },
      { field_id: 3, field_name: "อายุรกรรม" },
      { field_id: 4, field_name: "กุมารเวชกรรม" },
      { field_id: 5, field_name: "มะเร็งวิทยา" },
      { field_id: 6, field_name: "เภสัชกรรม" },
      { field_id: 7, field_name: "ออร์โธปิดิกส์" },
      { field_id: 8, field_name: "ระบาดวิทยา" },
      { field_id: 9, field_name: "พยาธิวิทยา" },
      { field_id: 10, field_name: "พยาบาล" },
      { field_id: 11, field_name: "อื่นๆ" },
    ],
    positionList: [
      { position_id: 1, position_name: "ผศ." },
      { position_id: 2, position_name: "รศ." },
      { position_id: 3, position_name: "ศ." },
      { position_id: 4, position_name: "ไม่มี" },
      { position_id: 5, position_name: "อื่นๆ" },
    ],
    teamList: [
      {team_name:'กองตรวจโรคผู้ป่วยนอก'},
      {team_name:'กองอุบัติเหตุและเวชกรรมฉุกเฉิน'},
      {team_name:'กองอายุรกรรม'},
      {team_name:'กองจิตเวชและประสาทวิทยา'},
      {team_name:'กองการพยาบาล'},
      {team_name:'กองรังสีกรรม'},
      {team_name:'กองวิสัญญีและห้องผ่าตัด'},
      {team_name:'กองออร์โธปิดิกส์'},
      {team_name:'กองเภสัชกรรม'},
      {team_name:'กองสูตินรีเวชกรรม'},
      {team_name:'กองกุมารเวชกรรม'},
      {team_name:'กองจักษุกรรม'},
      {team_name:'กองโสต ศอ นาสิกกรรม'},
      {team_name:'กองเวชศาสตร์ฟื้นฟู'},
      {team_name:'กองทันตกรรม'},
      {team_name:'กองศัลยกรรม'},
      {team_name:'กองพยาธิวิทยา'},
      {team_name:'อื่นๆ'},
    ],
    affiliationList: [],
    form: {
      nameTitleID: "",
      rankID: "",
      preNameTh: "",
      preNameEn: "",
      thName: "",
      enName: "",
      thFirstName: "",
      enFirstName: "",
      thLastName: "",
      enLastName: "",
      mobilePhone: "",
      email: "",
      password: "",
      password_confirmation: "",
      role: [],
      gender: "",
      pictureFile: "",
      signatureImage: "",
      signatureImageEN: "",
      scMastery: "",
      scPosition: "",
      scTeam: "",
      scAffiliation: "",
      otherScMastery: "",
      otherScPosition: "",
      otherScTeam: "",
      otherScAffiliation: "",
      orderNumber: "",
      orderDate: "",
      isScientist: "",
      isAffiliated: "",
      training: [],
    },
    isOtherField: true,
    isOtherPosition: true,
    isOtherTeam: true,
    isOtherAffiliation: true,
    titleName: [],
    rankName: [],
    imageUrl: "",
    imageUrlSignature: "",
    imageUrlSignatureEN: "",
    year: "",
    fixTraining: [
      { trainingName: "SOP", trainingDate: "", trainingDateShow: "" },
      { trainingName: "GCP", trainingDate: "", trainingDateShow: "" },
      {
        trainingName: "จริยธรรมการวิจัยในมนุษย์",
        trainingDate: "",
        trainingDateShow: "",
      },
    ],
    orderChangeDate: "",
    roleList: [
      {
        roleID: 1,
        role: "เจ้าหน้าที่",
      },
      {
        roleID: 2,
        role: "เลขานุการ",
      },
      {
        roleID: 3,
        role: "คณะอนุกรรมการฯ",
      },
      {
        roleID: 4,
        role: "ประธาน",
      },
    ],
  }),
  async created() {
    await this.getAffiliationList();
    if (this.$route.query.id !== "add") {
      await this.getUser();
    }
    this.getTitle();
    this.getRank();
  },

  methods: {
    async getTitle() {
      const res = await this.$store.dispatch("Common/getTitleName");
      res.forEach((data) => {
        this.titleName.push({
          title_name_th: data.thTitle,
          title_id: data.id,
        });
      });
    },
    getAffiliationList() {
      this.affiliationList = [];
      this.isLoading = true;
      this.$store.dispatch("Common/getAffiliationList").then((res) => {
        res.forEach((data) => {
          this.affiliationList.push({
            affiliation_id: data.id,
            affiliation_name: data.affiliation,
          });
        });
        this.isLoading = false;
      });
    },
    async getRank() {
      const res = await this.$store.dispatch("Common/getRank");
      res.forEach((data) => {
        this.rankName.push({
          rank_name_th: data.name_th,
          rank_id: data.id,
        });
      });
    },
    checkRole(role, name) {
      if (role === 1) {
        switch (name) {
          case "isPresident":
            this.form.role.push(4);
            break;
          case "isReviewer":
            this.form.role.push(3);
            break;
          case "isSecretary":
            this.form.role.push(2);
            break;
          case "isStaff":
            this.form.role.push(1);
            break;
        }
      }
    },
    getUser() {
      this.isLoading = true;
      this.$store
        .dispatch("User/getUserById", this.$route.query.id)
        .then((res) => {
          console.log(res);
          this.form.gender = res.gender ? res.gender.toString() : '';
          this.form.rankID = res.rankID;
          this.form.preNameTh = res.preNameTh;
          this.form.preNameEn = res.preNameEn;
          this.form.thName = res.thName;
          this.form.enName = res.enName;
          this.form.thFirstName = res.thFirstName;
          this.form.enFirstName = res.enFirstName;
          this.form.thLastName = res.thLastName;
          this.form.enLastName = res.enLastName;
          this.form.mobilePhone = res.mobilePhone;
          this.form.email = res.email;
          this.form.password = res.password;
          this.form.password_confirmation = res.password_confirmation;
          this.checkRole(res.isPresident, "isPresident");
          this.checkRole(res.isReviewer, "isReviewer");
          this.checkRole(res.isSecretary, "isSecretary");
          this.checkRole(res.isStaff, "isStaff");
          this.form.pictureFile = res.pictureFile;
          this.imageUrl = res.pictureFilePath;
          this.form.signatureImage = res.signatureImage;
          this.imageUrlSignature = res.signatureImagePath;
          this.form.signatureImageEN = res.signatureImageEN;
          this.imageUrlSignatureEN = res.signatureImageENPath;
          this.updateData("scMastery", res.scMastery);
          this.updateData("scPosition", res.scPosition);
          this.updateData("scTeam", res.scTeam);
          this.updateData("scAffiliation", parseInt(res.scAffiliation));
          this.form.otherScMastery = res.otherScMastery;
          this.form.otherScPosition = res.otherScPosition;
          this.form.otherScTeam = res.otherScTeam;
          this.form.otherScAffiliation = res.otherScAffiliation;
          this.form.orderNumber = res.orderNumber;
          this.orderChangeDate = res.orderDate
            ? this.changeDate(res.orderDate)
            : "";
          this.form.orderDate = res.orderDate;
          if (res.sc_training.length > 0) {
            this.fixTraining = res.sc_training;
            res.sc_training.forEach((data, i) => {
              this.fixTraining[i].trainingDateShow = this.changeDate(
                data.trainingDate
              );
              this.fixTraining[i].trainingDate = data.trainingDate;
            });
          }
          this.form.isScientist = res.isScientist
            ? res.isScientist.toString()
            : "";
          this.form.isAffiliated = res.isAffiliated
            ? res.isAffiliated.toString()
            : "";
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
          this.isLoading = false;
        });
    },
    updateUser() {
      if (!this.form.pictureFile) {
        this.form.pictureFile = "default614788644.png";
      }
      if (this.$route.query.id === "add") {
        this.form.training = this.fixTraining;
        this.$store
          .dispatch("Auth/adminRegister", this.form)
          .then((res) => {
            this.isLoading = false;
            Swal.fire({
              title: "Success",
              text: "อัพเดทข้อมูลเรียบร้อย",
              confirmButtonColor: "#3E7662",
            }).then(() => {
              this.$router.push("/admin-management");
            });
          })
          .catch((e) => {
            this.isLoading = false;
            if (e.response.data.errors) {
              for (var k in e.response.data.errors) {
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: e.response.data.errors[k][0],
                  icon: "warning",
                  confirmButtonColor: "#3E7662",
                }).then(() => {
                  this.$vuetify.goTo(`#${k}`);
                });
              }
            }
          });
      } else {
        this.form.training = this.fixTraining;
        this.form["userID"] = this.$route.query.id;
        this.$store
          .dispatch("Auth/adminUpdate", this.form)
          .then((res) => {
            this.isLoading = false;
            Swal.fire({
              title: "Success",
              text: "แก้ไขข้อมูลเรียบร้อยแล้ว",
              confirmButtonColor: "#3E7662",
            }).then(() => {
              this.$router.push("/admin-management");
            });
          })
          .catch((e) => {
            this.isLoading = false;
            if (e.response.data.errors) {
              for (var k in e.response.data.errors) {
                Swal.fire({
                  title: "เกิดข้อผิดพลาด",
                  text: e.response.data.errors[k][0],
                  icon: "warning",
                  confirmButtonColor: "#3E7662",
                }).then(() => {
                  this.$vuetify.goTo(`#${k}`);
                });
              }
            }
          });
      }
    },
    onFilePicked(e) {
      this.$store
        .dispatch("Common/uploadImage", { file: e, name: "image-profile" })
        .then((res) => {
          this.imageUrl = res.filePath;
          this.form.pictureFile = res.fileName;
        })
        .catch((e) => {
          document.getElementById("file").value = "";
          Swal.fire({
            title: "เกิดข้อผิดพลาด",
            text: "นามสกุลรูปภาพไม่ถูกต้อง (แนะนำ .jpg, .png)",
            icon: "warning",
            confirmButtonColor: "#3E7662",
          });
        });
    },
    onUploadSignaturePicked(e) {
      console.log('e',e)
      this.isLoadingUpload = true;
      this.$store
        .dispatch("Common/uploadImage", { file: e, name: "image-signature" })
        .then((res) => {
          this.imageUrlSignature = res.filePath;
          this.form.signatureImage = res.fileName;
          this.isLoadingUpload = false;
        })
        .catch((e) => {
          document.getElementById("signature").value = "";
          Swal.fire({
            title: "เกิดข้อผิดพลาด",
            text: "นามสกุลรูปภาพไม่ถูกต้อง หรือ ขนาดภาพไม่เกิน 2 MB",
            icon: "warning",
            confirmButtonColor: "#3E7662",
          });
          this.isLoadingUpload = false;
        });
    },
    onUploadSignaturePickedEN(e) {
      console.log('e',e)
      this.isLoadingUpload = true;
      this.$store
        .dispatch("Common/uploadImage", { file: e, name: "image-signature" })
        .then((res) => {
          this.imageUrlSignatureEN = res.filePath;
          this.form.signatureImageEN = res.fileName;
          this.isLoadingUpload = false;
        })
        .catch((e) => {
          document.getElementById("signatureEN").value = "";
          Swal.fire({
            title: "เกิดข้อผิดพลาด",
            text: "นามสกุลรูปภาพไม่ถูกต้อง หรือ ขนาดภาพไม่เกิน 2 MB",
            icon: "warning",
            confirmButtonColor: "#3E7662",
          });
          this.isLoadingUpload = false;
        });
    },
    uploadFile() {
      document.getElementById("file").click();
    },
    uploadSignature() {
      document.getElementById("signature").click();
    },
    uploadSignatureEN() {
      document.getElementById("signatureEN").click();
    },
    updateData(name, val) {
      this.form[name] = val;
      switch (name) {
        case "province":
          this.getDistricts(val);
          break;
        case "district":
          this.getSubDistricts(val);
          break;
        case "scMastery":
          this.isOtherField = this.form["scMastery"] !== "อื่นๆ";
          this.form["otherScMastery"] = "";
          break;
        case "scPosition":
          this.isOtherPosition = this.form["scPosition"] !== "อื่นๆ";
          this.form["otherScPosition"] = "";
          break;
        case "scTeam":
          this.isOtherTeam = this.form["scTeam"] !== "อื่นๆ";
          this.form["otherScTeam"] = "";
          break;
        case "scAffiliation":
          this.isOtherAffiliation = this.form["scAffiliation"] !== 15;
          this.form["otherScAffiliation"] = "";
          break;
        default:
        // code block
      }
    },
    updateDate(name, val) {
      if (name === "trainingDate1") {
        this.fixTraining[0].trainingDate = val.date;
        this.trainingDate1 = val.changeDate;
      }
      if (name === "trainingDate2") {
        this.fixTraining[1].trainingDate = val.date;
        this.trainingDate2 = val.changeDate;
      }
      if (name === "trainingDate3") {
        this.fixTraining[2].trainingDate = val.date;
        this.trainingDate3 = val.changeDate;
      }
      if (name === "orderDate") {
        this.form.orderDate = val.date;
        this.orderChangeDate = val.changeDate;
      }
    },
    updateTrainingDate(index, val) {
      this.fixTraining[index].trainingDate = val.date;
      this.fixTraining[index].trainingDateShow = this.changeDate(val.date);
      this.$forceUpdate()
    },
    updateTrainingName(index, val) {
      this.fixTraining[index].trainingName = val;
      this.$forceUpdate()
    },
    add(index) {
      this.fixTraining.push({ trainingName: "", trainingDate: "" });
    },
    remove(index) {
      this.fixTraining.splice(index, 1);
    },
    changeDate(val) {
      //change date start
      let sub_year = val.substring(0, 4);
      let sub_month = val.substring(5, 7);
      let sub_day = val.substring(8, 10);
      sub_year = parseInt(sub_year) + 543;
      let changeDate = sub_day + "/" + sub_month + "/" + sub_year;
      return changeDate;
    },
    deleteUser() {
      Swal.fire({
        title: "คุณต้องการลบข้อมูลหรือไม่?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3E7662",
        cancelButtonColor: "rgb(189, 189, 189)",
        confirmButtonText: "ใช่",
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$store
            .dispatch("User/deleteUser", this.$route.query.id)
            .then((res) => {
              Swal.fire({
                position: "center",
                icon: "success",
                title: "ลบข้อมูลสำเร็จ",
                showConfirmButton: false,
                timer: 1500,
              });
              this.isLoading = false;
              setTimeout(() => {
                this.$router.go(-1);
              }, 1500);
            })
            .catch((e) => {
              Swal.fire({
                title: "Save failed!",
                text: "ลบข้อมูลไม่สำเร็จ",
                icon: "warning",
              });
              this.isLoading = false;
            });
        }
      });
    },
  },
};
</script>

<style scoped></style>
